import { useDeferredValue, useState } from "react";

import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { BonusCardBalanceResponse } from "@/api/hooks/customerService.types";
import { DefaultFor } from "@/api/mappers/default.mapper";

import BonusCardBalance from "./BonusCardBalance/bonusCardBalance.component";
import { BonusCardRequestBalanceForm } from "./bonusCardRequestBalance.component";

const BonusCardRequestBalanceContainer = () => {
    const [bonusCardnumber, setBonusCardnumber] = useState("");
    const [{ data, error, loading }, fetchBonusCard] = useCustomerServiceApi(
        {
            url: "/bonuscards/:bonusCardnumber",
            method: "GET",
            mapper: DefaultFor<BonusCardBalanceResponse>(),
            urlParams: {
                bonusCardnumber
            }
        },
        { manual: true, useCache: false, autoCancel: false }
    );
    const deferredBonusCardNumber = useDeferredValue(bonusCardnumber);

    const onRequestBalanceFor = async (bonusCardNumber: string) => {
        setBonusCardnumber(bonusCardNumber);

        if (!bonusCardNumber) {
            return;
        }

        try {
            await fetchBonusCard({
                urlParams: { bonusCardnumber: bonusCardNumber }
            });
        } catch {
            return;
        }
    };

    const canShow = data && !!deferredBonusCardNumber && !error && !loading;

    return (
        <>
            <BonusCardRequestBalanceForm
                loading={loading}
                onRequestBalanceFor={onRequestBalanceFor}
                bonusCardnumber={bonusCardnumber}
                error={error}
            />
            {canShow && <BonusCardBalance balance={data.balance} />}
        </>
    );
};

export { BonusCardRequestBalanceContainer };
